import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import { Formik } from 'formik';
import * as yup from 'yup';
import * as analytics from '../../services/analytics';
import ModalEnrollmentRejection from '../ModalEnrollmentRejection';
import './BOAEnrollmentADDView.css';

const propTypes = {
  onSubmit: PropTypes.func,
};

class BOAEnrollmentADDView extends PureComponent {
  constructor(props) {
    super(props);
    this.formValidationSchema = yup.object().shape({
      hasADDCoverage: yup
        .mixed()
        .oneOf(['yes', 'no'])
        .required(`Please select an option to continue.`),
    });
    this.state = {
      isInProgress: false,
      isValid: this.formValidationSchema.isValidSync(this.initialFormValues),
    };
  }

  componentDidMount() {
    analytics.page('BOA - Enrollment AD&D Coverage');
  }

  componentWillUnmount() {
    this.rejectionModal.hide();
  }

  handleInitialValidation = ({ initialValues }) => {
    return this.formValidationSchema.isValidSync(initialValues);
  };

  handleChange = (e) => {
    const { handleChange } = this.form;
    this.setState({
      isValid: this.formValidationSchema.isValidSync({
        region: e.target.value,
      }),
    });
    handleChange(e);
  };

  handleSubmit = (values) => {
    const { updateQuote, quote, onSubmit, onNotifyError } = this.props;
    const hasADDCoverage = values.hasADDCoverage === 'yes' ? true : false;
    if (hasADDCoverage) {
      this.showRejectionModal();
    } else {
      const updatedQuote = merge({}, quote, {
        application: {
          answers: {
            corporation_add_policy: hasADDCoverage,
          },
        },
      });
      this.setState({
        isInProgress: true,
      });
      updateQuote(updatedQuote)
        .then(onSubmit)
        .catch((error) => {
          this.setState({
            isInProgress: false,
          });
          onNotifyError(error);
        });
    }
  };

  showRejectionModal = (e) => {
    analytics.track('BOA - Enrollment Rejection Modal Displayed');
    this.rejectionModal.show();
  };

  get initialFormValues() {
    const {
      quote: { application },
    } = this.props;
    const hasADDCoverage = application.answers.corporation_add_policy;
    return {
      hasADDCoverage:
        (hasADDCoverage && 'yes') || (hasADDCoverage === false && 'no') || null,
    };
  }

  render() {
    return (
      <>
        <div className="container">
          <div className="row justify-content-center">
            <Formik
              initialValues={this.initialFormValues}
              isInitialValid={this.handleInitialValidation}
              validationSchema={this.formValidationSchema}
              onSubmit={this.handleSubmit}
              innerRef={(c) => (this.form = c)}
            >
              {({ values, handleSubmit, isValid }) => {
                return (
                  <div className="col-md-7 p-t-30">
                    <h3 className="text-center semi-bold">
                      Is there a group accidental death policy (or business
                      travel accident policy) currently in-force for this
                      business?
                    </h3>
                    <div className="BOAEnrollmentADDView-clientDetails card m-t-20">
                      <form
                        className="card-block p-l-30"
                        onSubmit={handleSubmit}
                      >
                        <div className="radio radio-success m-b-15">
                          <input
                            id="radioYes"
                            type="radio"
                            name="hasADDCoverage"
                            value="yes"
                            checked={values.hasADDCoverage === 'yes'}
                            onChange={this.handleChange}
                          />
                          <label
                            className="BOAEnrollmentADDView-radio"
                            htmlFor="radioYes"
                          >
                            <strong className="BOAEnrollmentADDView-radio-label">
                              Yes
                            </strong>
                          </label>
                        </div>
                        <div className="radio radio-success">
                          <input
                            id="radioNo"
                            type="radio"
                            name="hasADDCoverage"
                            value="no"
                            checked={values.hasADDCoverage === 'no'}
                            onChange={this.handleChange}
                          />
                          <label
                            className="BOAEnrollmentADDView-radio"
                            htmlFor="radioNo"
                          >
                            <strong className="BOAEnrollmentADDView-radio-label">
                              No
                            </strong>
                          </label>
                        </div>
                        <input
                          type="submit"
                          style={{ display: 'none' }}
                          ref={(c) => (this.inputSubmit = c)}
                        />
                      </form>
                    </div>

                    <div className="row justify-content-center">
                      <button
                        className="btn btn-lg btn-complete"
                        disabled={!isValid || this.state.isInProgress}
                        onClick={() => this.inputSubmit.click()}
                        type="button"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                );
              }}
            </Formik>
          </div>
        </div>
        <ModalEnrollmentRejection ref={(c) => (this.rejectionModal = c)} />
      </>
    );
  }
}

BOAEnrollmentADDView.propTypes = propTypes;

export default BOAEnrollmentADDView;
